// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1q2ZC","list":"styles_list__1EFtm"};